import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LongTermOptionsActions = {
  getLongTermOptions: async ({ dispatch }, { partyId }) => {
    return axiosRequest.
      get('/party_long_term_options', { params: { party_id: partyId } }).
      then(({ data }) => dispatch('processLoadedLTOs', data)).
      catch(handleError)
  },
  saveLongTermOption: async ({ dispatch }, { partyId, section }) => {
    if (section.id) return dispatch('updateLongTermOptions', { partyId, section })
    else return dispatch('createLongTermOptions', { partyId, section })
  },
  createLongTermOptions: async ({ commit }, { partyId, section }) => {
    return axiosRequest.
      post('/party_long_term_options', { party_id: partyId, section }).
      then(({ data }) => commit('updateLTO', data)).
      catch(handleError)
  },
  updateLongTermOptions: async ({ commit }, { partyId, section }) => {
    return axiosRequest.
      patch(`/party_long_term_options/${section.id}`, { party_id: partyId, section }).
      then(({ data }) => commit('updateLTO', data)).
      catch(handleError)
  },

  processLoadedLTOs: ({ commit }, optionList) => {
    for (const option of optionList) commit('updateLTO', option)
  },
}
